import AuthorizedPermission from '@/components/AuthorizedPermission';
import { addPermissionByLoop, CreateRoutersProps, DOMRouterOpts, getBase, RoutePathItem } from '@maxtropy/components';

import { FullScreenOutlet, MainOutlet } from './outlets';
import otherRoutes from './other';
import mainRoutesPaths from './main';
import { createBrowserRouter, Outlet, useLocation, useNavigation } from 'react-router-dom';
import React, { useEffect } from 'react';
import ErrorBoundary from '@maxtropy/web-monitor/es/Boundary';

const RootWrapper = () => {
  const location = useLocation();

  const navigation = useNavigation();

  // 在微前端环境下，路由跳转时触发popstate事件，使主应用监听到路由变化
  useEffect(() => {
    if (!window.__MICRO_APP_ENVIRONMENT__) return;
    window.__PAGE_LOAD_DISPATCHED__ = false;

    window.rawWindow.dispatchEvent(new PopStateEvent('popstate', { state: null }));
  }, [location]);

  useEffect(() => {
    if (navigation.state === 'idle' && window.__MICRO_APP_ENVIRONMENT__ && !window.__PAGE_LOAD_DISPATCHED__) {
      window.__PAGE_LOAD_DISPATCHED__ = true; // 标记只发一次
      // 发送 CustomEvent 给主应用
      window.rawWindow.dispatchEvent(
        new CustomEvent('micro-app-loaded', {
          detail: {
            name: 'ms-ids', // 子应用名称
            data: { loaded: true },
          },
        })
      );
    }
  }, [navigation.state]);

  return <Outlet />;
};

const routes: RoutePathItem[] = [
  {
    errorElement: <ErrorBoundary />,
    element: <RootWrapper />,
    children: [
      {
        element: <FullScreenOutlet />,
        children: [...otherRoutes],
      },
      {
        element: <MainOutlet />,
        children: [...mainRoutesPaths],
      },
    ],
  },
];

const createRouters = (parameters: CreateRoutersProps, opt?: DOMRouterOpts) => {
  const { routes, render } = parameters;
  const pagesRoutes = addPermissionByLoop({ routes, render });
  return createBrowserRouter(pagesRoutes, opt);
};

// 递归添加AuthorizedPermission,并创建路由对象
const routers = createRouters(
  {
    routes,
    render: (pers, ele, theme) => {
      return (
        <AuthorizedPermission theme={theme} permissionKey={pers}>
          {ele}
        </AuthorizedPermission>
      );
    },
  },
  {
    basename: getBase(),
  }
);

export default routers;
